import React, { lazy, Suspense, useContext } from "react";
import { PayCycles } from "./PayCycles";
import loader from "../content/images/icon_loading.gif";
import ConfigContext from "../context/ConfigContext";

const ViewAs = lazy(() => import("./ViewAs"));

export const RepInfo = ({ viewer, clientNumber, setClientNumber, setPayPeriod, loading }) => {
	const configData = useContext(ConfigContext);
	const branchLink = viewer.branchURL !== "N/A" ? <a href={viewer.branchURL} target="_blank" rel="noreferrer">Go to Branch View</a> : "N/A";
	const featureActive = configData.REACT_APP_ADVISOR_INSIGHTS_RELEASE_DATE ? new Date() >= new Date(configData.REACT_APP_ADVISOR_INSIGHTS_RELEASE_DATE) : false;
	let options;

	if (featureActive) {
		options =
			<div className="row" style={{ minHeight: "60px" }}>
				<div className="col-sm-4 col-md-4 col-lg-4">
					<Suspense fallback={<img src={loader} alt="Loading " />}>
						<ViewAs setClientNumber={setClientNumber} />
					</Suspense>
				</div>
				<div className="col-sm-4 col-md-4 col-lg-4">
					{loading ? <img src={loader} alt="Loading " /> : <PayCycles setPayPeriod={setPayPeriod} clientNumber={clientNumber} />}
				</div>
				<div className="col-sm-4 col-md-4 col-lg-4">
					<label>Last Paid</label><br></br>
					<p className="AppP">{loading ? <img src={loader} alt="Loading " /> : viewer.lastPaid}</p>
				</div>
			</div>;
	} else {
		options =
			<div className="row" style={{ minHeight: "60px" }}>
				<div className="col-sm-6 col-md-6 col-lg-6">
					<Suspense fallback={<img src={loader} alt="Loading " />}>
						<ViewAs setClientNumber={setClientNumber} />
					</Suspense>
				</div>
				<div className="col-sm-6 col-md-6 col-lg-6">
					{loading ? <img src={loader} alt="Loading " /> : <PayCycles setPayPeriod={setPayPeriod} clientNumber={clientNumber} />}
				</div>
			</div>;
	}

	return (
		<div className="box-layout" style={{ marginBottom: "20px" }}>
			<div className="row" style={{ minHeight: "40px" }}>
				<h2><a href={viewer.repURL} target="_blank" rel="noreferrer">{loading ? <img src={loader} alt="Loading " /> : viewer.repFullName}</a></h2>
			</div>
			<div className="row" style={{ minHeight: "107px" }}>
				<div className="col-sm-4 col-md-4 col-lg-2">
					<label>Rep Code</label>
					<p className="AppP">{loading ? <img src={loader} alt="Loading " /> : viewer.primaryRepCode}</p>
				</div>
				<div className="col-sm-8 col-md-8 col-lg-10">
					<label>{loading ? <img src={loader} alt="Loading " /> : viewer.branchName}</label>
					<p className="AppP">{loading ? <img src={loader} alt="Loading " /> : viewer.address}</p>
					<p className="AppP">{loading ? <img src={loader} alt="Loading " /> : branchLink}</p>
				</div>
			</div>
			{options}
		</div>
	);
};